var moduleMap = {
	"./components": () => {
		return Promise.all([__webpack_require__.e(655), __webpack_require__.e(220), __webpack_require__.e(928), __webpack_require__.e(920), __webpack_require__.e(926), __webpack_require__.e(519), __webpack_require__.e(999), __webpack_require__.e(921), __webpack_require__.e(314), __webpack_require__.e(100), __webpack_require__.e(699), __webpack_require__.e(545)]).then(() => (() => ((__webpack_require__(1545)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(926), __webpack_require__.e(699)]).then(() => (() => ((__webpack_require__(1699)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});